export default {
  root: ({ instance, context }) => ({
    class: ["slider-root"],
  }),
  track: ({ context }) => ({
    class: ["slider-track", { "slider-track_disabled": context?.disabled }],
  }),
  range: () => ({
    class: ["slider-range"],
  }),
  starthandler: ({ context }) => ({
    class: ["slider-handle"],
  }),
  endhandler: ({ context }) => ({
    class: ["slider-handle"],
  }),
  input: () => ({
    class: ["slider-input"],
  }),
};
